import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HiroApi, HiroApiImpl } from './apis';

export const hiroContainer = new ContainerModule((bind) => {
    bind(HiroApi).to(HiroApiImpl);
});
